export const CATEGORIES = [
  'Arts & Concerts',
  'Community Service',
  'Cultural',
  'Health & Wellness',
  'Lectures & Workshops',
  'Meetings',
  'Professional',
  'Parties & Socials',
  'Sports & Fitness',
];

export type Category = typeof CATEGORIES[number];
